import React, { Component } from 'react';
import Flipper from './Flipper';

export default class Fcard extends Component {
  constructor() {
    super();
    this.state = {
      flipped: false,
    };
    this.flip = this.flip.bind(this);
  }
  switchModal(item) {
    this.props.switchModal(item);
  }
  componentDidMount() {
    this.flip = this.flip.bind(this);
  }
  flip() {
    this.setState({ flipped: !this.state.flipped });
  }

  openNutritionInfo() {
    this.props.openNutritionInfo();
  }

  render() {
    return (
      <div>
        <Flipper
          flipped={this.state.flipped}
          orientation="horizontal"
          flip={() => this.flip()}
          switchModal={clickedItem => this.switchModal(clickedItem)}
          item={this.props.item}
          openNutritionInfo={() => this.openNutritionInfo()}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/dashboard/components/items/Fcard.jsx